import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import { Flex, Img, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  labels: string[];
  onChange?: (index: number) => void;
  index?: number;
  width?: string;
  panels?: { src: string; alt: string }[];
  backgroundColor?: string;
}

function LandingPageTabs({
  labels,
  onChange,
  index,
  width,
  panels,
  backgroundColor,
}: Props) {
  const { tSentence, i18n } = useI18nHelper();
  const isKor = i18n.language === "ko";

  return (
    <Tabs variant="unstyled" onChange={onChange} index={index} flex={1}>
      <TabList
        background={"#F2F2F2"}
        borderRadius={"10px"}
        color={"#737373"}
        fontSize={"16px"}
        fontWeight={500}
        lineHeight={"24px"}
        whiteSpace={"nowrap"}
        padding={"2px"}
      >
        {labels.map((label, idx) => (
          <Tab
            _selected={{ color: "#555555", bg: "#FFFFFF" }}
            width={width ?? "80px"}
            borderRadius={"2px"}
            key={idx}
            flex={1}
            padding={"6px 8px"}
            style={{
              borderRadius: "8px",
            }}
          >
            <Text
              fontSize={isKor ? "16px" : "13px"}
              fontWeight={500}
              lineHeight={"24px"}
              // noOfLines={1}
              isTruncated={true}
            >
              {tSentence("landing:" + label)}
            </Text>
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {panels?.map((panel, idx) => (
          <TabPanel padding={0} paddingTop={"16px"} key={idx}>
            <Flex
              justifyContent={"center"}
              alignItems={"center"}
              background={backgroundColor ?? "#F8F8F8"}
              borderRadius={"16px"}
            >
              <Img src={panel.src} alt={panel.alt} />
            </Flex>
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
}

export default LandingPageTabs;
